import { render, staticRenderFns } from "./SetHook.vue?vue&type=template&id=16f0da7c&scoped=true&"
import script from "./SetHook.vue?vue&type=script&lang=js&"
export * from "./SetHook.vue?vue&type=script&lang=js&"
import style0 from "./SetHook.vue?vue&type=style&index=0&id=16f0da7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f0da7c",
  null
  
)

export default component.exports